/* ----------------- React Native Paper --------------- */
import { isWeb } from "@memorang/helpers/platform";
import { List, Text } from "react-native-paper";

import Icon from "@react-native-vector-icons/material-design-icons/static";
import type { CursorValue } from "react-native";
import type { IconType } from "../../../icon";
import CustomChip from "../../CustomChip";
/* ----------------- Components --------------- */
import TooltipWrapper from "../../TooltipWrapper";

type Props = {
	icon: string;
	title: string;
	description: string;
	chipLabel: string;
	iconColor: string;
	tooltip?: string;
};

const chipProps = {
	textStyle: {
		cursor: "help" as unknown as CursorValue,
	},
};
export const SummaryListItem = ({
	icon,
	title,
	description,
	chipLabel,
	iconColor,
	tooltip,
}: Props) => (
	<List.Item
		title={<Text variant="bodyMedium">{title}</Text>}
		description={<Text variant="bodySmall">{description}</Text>}
		style={{
			paddingRight: 16,
			cursor: "default" as unknown as CursorValue,
			paddingVertical: 4,
		}}
		left={(props) => (
			<List.Icon
				{...props}
				color={iconColor}
				icon={(props) => <Icon name={icon as IconType} {...props} />}
			/>
		)}
		right={(p) => (
			<List.Icon
				{...p}
				icon={() =>
					tooltip ? (
						<TooltipWrapper title={tooltip!}>
							<CustomChip {...(isWeb ? { ...chipProps } : {})} hasTooltip>
								{chipLabel}
							</CustomChip>
						</TooltipWrapper>
					) : (
						<CustomChip>{chipLabel}</CustomChip>
					)
				}
			/>
		)}
	/>
);
